<script setup lang="ts">
import type { StickerFill, StickerTilt } from './SfgSticker.vue'

withDefaults(defineProps<{
  bottom?: string
  diameter?: number | string
  fill?: StickerFill
  middle?: string
  scale?: number | string
  tilt?: StickerTilt
  top?: string
}>(), {
  bottom: undefined,
  diameter: 140,
  fill: 'ink',
  middle: undefined,
  scale: undefined,
  tilt: 3,
  top: undefined,
})
</script>

<template>
  <SfgSticker
    :fill
    variant="badge"
    :tilt
    :dashed="false"
    size="md"
    :scale
  >
    <div
      :style="{ width: typeof diameter === 'number' ? `${diameter}px` : diameter, height: typeof diameter === 'number' ? `${diameter}px` : diameter }"
      class="flex flex-col items-center justify-center rounded-full"
      style="border: 3px solid currentColor"
    >
      <span v-if="top" class="font-display text-[12px] tracking-[0.1em] uppercase">{{ top }}</span>
      <span
        v-if="middle"
        class="font-editorial italic font-black leading-none my-1 text-[28px]"
      >{{ middle }}</span>
      <span v-if="bottom" class="font-display text-[12px] tracking-[0.1em] uppercase">{{ bottom }}</span>
    </div>
  </SfgSticker>
</template>
